// extracted by mini-css-extract-plugin
export default {"AdminFooter":"AdminFooter_AdminFooter__30FxD"};